import { compose } from 'redux';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'react-emotion';

import AMPLITUDE_EVENT_NAMES from '../../../amplitude/constants';
import AuthForm from '../AuthForm';
import ErrorMessage from '../../../components/Messages/ErrorMessage';
import { FIELDS } from './constants';
import { handleKeyDown } from '../../../helpers/utils';
import InputText from '../../../components/Form/InputText';
import { initiateSignUp } from '../../../redux/actions/signUp';
import { logAmplitudeEvent } from '../../../redux/actions/amplitude';
import PageHeader from '../../../components/PageHeader/PageHeader';
import { RouterLink } from '../../../components/Text/Text';
import Style from '../../../styles/common';
import SubmitButton from '../../../components/Buttons/SubmitButton';
import { validateEmail, validateNotEmpty } from '../../../helpers/validations';

const Container = styled('div')`
  flex-grow: 1;
`;

const Form = styled('form')`
  margin-bottom: ${Style.SPACING.XXL};
  width: 400px;
`;

class SignUpForm extends React.Component {
  static propTypes = {
    hasFailed: PropTypes.bool,
    initiateSignUp: PropTypes.func.isRequired,
    isSubmitting: PropTypes.bool,
  };

  static defaultProps = {
    hasFailed: false,
    isSubmitting: false,
  };

  componentDidMount() {
    this.props.logAmplitudeEvent(AMPLITUDE_EVENT_NAMES.SIGN_UP_SHOW_FORM);
  }

  render() {
    return (
      <Container>
        <PageHeader>Sign up</PageHeader>
        <AuthForm>
          <Form
            onKeyDown={this.onKeyDown}
            onSubmit={this.props.handleSubmit(this.onSubmit)}
          >
            <Field
              component={InputText}
              label="Email"
              name={FIELDS.EMAIL}
              placeholder="info@allthese.events"
              type="text"
              validate={[validateNotEmpty, validateEmail]}
            />
            <Field
              component={InputText}
              label="Password"
              name={FIELDS.PASSWORD}
              placeholder="•••••••••••••"
              type="password"
              validate={validateNotEmpty}
            />
            <Field
              component={InputText}
              label="Organization"
              name={FIELDS.ORGANIZATION}
              placeholder="All These Events"
              type="text"
            />
            <SubmitButton
              disabled={this.props.isSubmitting}
              loading={this.props.isSubmitting}
              type="submit"
            >
              Sign up
            </SubmitButton>
            {this.errorMessage}
          </Form>
          <p>
            Already a member?{' '}
            <RouterLink to="/auth">Sign in</RouterLink>
          </p>
        </AuthForm>
      </Container>
    );
  }

  onSubmit = values => {
    this.props.initiateSignUp(values);
  };

  onKeyDown = e => {
    handleKeyDown(e, this.props.handleSubmit(this.onSubmit));
  };

  get errorMessage() {
    if (this.props.hasFailed || this.props.submitFailed) {
      return <ErrorMessage shouldAnimate={true}>Failed to sign up</ErrorMessage>;
    }
    return null;
  }
}

export default compose(
  connect(
    state => ({
      hasFailed: state.signUp.hasFailed,
      isSubmitting: state.signUp.isRequesting,
    }),
    { initiateSignUp, logAmplitudeEvent },
  ),
  reduxForm({
    form: 'signUpForm',
    initialValues: {
      [FIELDS.EMAIL]: '',
      [FIELDS.PASSWORD]: '',
      [FIELDS.ORGANIZATION]: '',
    },
  }),
)(SignUpForm);



// WEBPACK FOOTER //
// ./src/views/Auth/SignUpForm/SignUpForm.js